import { render } from "./ObjectiveWeights.vue?vue&type=template&id=e168e0be&scoped=true"
import script from "./ObjectiveWeights.vue?vue&type=script&lang=js"
export * from "./ObjectiveWeights.vue?vue&type=script&lang=js"

import "./ObjectiveWeights.vue?vue&type=style&index=0&id=e168e0be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e168e0be"]])

export default __exports__